import styled from "styled-components";

export const StyledParagraph = styled.p`
  font-size: clamp(0.2rem, calc(1rem + 0.6vmax + 0.3vw), 30rem);
  font-weight: ${props => props.fontWeight};
  font-family: ${props => props.theme.font.familyInter};
  color: ${(props) => props.color};
`;
